import React, { Fragment } from 'react';
import moment from 'moment';

import MUIDataTable from "mui-datatables";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import NumberFormat from 'react-number-format';
import Notification from '../Notifications';
import { PayMethodsApi } from '../../api/paymethods_api';
import { PurchaseApi } from '../../api/purchaseApi';
import Warning from '@material-ui/icons/Warning';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FormGroup from '@material-ui/core/FormGroup';
import _ from "lodash";
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import NotInterested from '@material-ui/icons/NotInterested'


import { ThemeProvider } from "@material-ui/styles";

import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import esLocale from "date-fns/locale/es";

import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    DatePicker,
} from '@material-ui/pickers';

import { muitheme } from '../../theme/muiTheme'

const options = {
    selectedRows: {
        text: "fila(s) seleccionada",
        delete: "Cancelar orden completa",
        deleteAria: "Cancelar orden completa"
    },
    selectableRows: false, // <===== will turn off checkboxes in rows
    downloadOptions: {
        filename: 'ordenes_de_compra_cancelables.csv',
        separator: ','
    },
    textLabels: {
        body: {
            noMatch: "No hay Ordenes de compra con ese criterio",
            toolTip: "Sort",
        },
        pagination: {
            next: "Siguiente pag",
            previous: "Anterior",
            rowsPerPage: "Filas por pagina:",
            displayRows: "de",
        },
        toolbar: {
            search: "Buscar",
            downloadCsv: "Descargar CSV",
            print: "Imprimir",
            viewColumns: "Ver columnas",
            filterTable: "Filtrar tabla",
        },
        selectedRows: {
            text: "fila(s) seleccionadas",
            delete: "Cancelar orden completa",
            deleteAria: "Cancelar orden completa",
        },

    },

}


const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
};

const percentageLimit = (val) => {
    if (val === 0) {
        val = 1
    } else if (val > 1000) {
        val = 1000
    } else if (val < -1000) {
        val = -1000
    }
    return val
}

function PercentageFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (

        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: percentageLimit(values.value),
                    },
                });
            }}
            decimalScale={2}
            allowNegative={true}
            thousandSeparator={'.'}
            decimalSeparator={','}
            suffix="%"
        />
    );
}


export class CreditNoteView extends React.Component {

    constructor() {
        super();
        this.state = {
            newCreditNote: true,
            creditNoteToSearch: null,
            creditNoteTotal: 0,
            customerId: null,
            poDate: null,
            prodCod: null,
            quotes: null,
            showMsg: false,
            duration: 3000,
            msgType: 'success', // or 'error'
            msg: null,
            targetPos: null,
            prodsToCr: [],
            poToCr: null,
            disabledCreate: false,
            columns: [
                {
                    name: <strong>Numero de orden</strong>,
                    // options: {
                    //     setCellHeaderProps: () => {
                    //         return {
                    //             className: clsx({
                    //                 [classes.centeredTableHead]: true,
                    //             })
                    //         }
                    //     }
                    // }
                },
                { name: <strong>Fecha</strong> },
                {
                    name: <strong>Monto Total</strong>, options: {
                        display: true,
                        filter: false,
                        customBodyRender: value => <NumberFormat
                            value={value}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />


                    }
                },
                { name: <strong>Forma de Pago</strong> },
                { name: <strong>Cliente</strong> },
                { name: <strong>Producto Seleccionado</strong> },
                {
                    name: <strong>Otros Productos</strong>, options: {
                        customBodyRender: value => {
                            return <div> {value.map(function (item) {
                                return <div id={item.cod}><b>{item.cod}  x </b>{item.total_items} Unidad(es)</div>
                            })}
                            </div>
                        }
                    }
                },
            ],

            title: "Ordenes de compra Hasta 21 dias atras",
            poCatalog: []
        }

        options['onRowClick'] = this.selectPo

    }
    searchCreditNote = (e) => {
        PurchaseApi.getCreditNote(this.state.creditNoteToSearch)
            .then(response => {
                const creditNote = response.data
                this.setState({ creditNoteSearched: creditNote })
            })
            .catch(error => {
                if (error.response.status == 405) {
                    this.setState({ processing: false, msg: "Nota de credito invalida", msgType: 'error', showMsg: true })
                } else {
                    console.log(error)
                    this.setState({ processing: false, msg: "Error", msgType: 'error', showMsg: true })

                }
                console.log(error)
            })

    }


    selectPo = (rowData, rowMeta) => {
        this.setState({ poToCr: this.state.targetPos[rowData[0]] })
    }

    setcodProd = (e) => {
        if (isNaN(parseInt(e.target.value))) {
            this.setState({ prodCod: '' })

        }
        else {
            this.setState({ prodCod: parseInt(e.target.value) })
        }
    }

    handleClose = () => {
        this.setState({ showMsg: false })
    }

    loadPurchaseOrders = () => {
        let prodCod = this.state.prodCod
        if (prodCod == '' || prodCod == null || parseInt(prodCod) == NaN){
            prodCod = '0'
        }
        let poDate = null;

        if (this.state.poDate) {
            let date = this.state.poDate.toLocaleDateString()
            let poDate_split = date.split('/')
            poDate = poDate_split[2] + '-' + poDate_split[0] + '-' + poDate_split[1]
        }

        PurchaseApi.getList(prodCod, poDate)
            .then(response => {
                let rows = []
                let posList = {}
                let customerId = null
                const targetProd = this.state.prodCod
                response.data.results.map(function (pO) {
                    let otherItems = []
                    let targetItem = null
                    pO.order_items.map(function (item) {
                        if (item.voided != true) {
                            if (item.product.id == targetProd) {
                                targetItem = (item.total_items - item.voided_items) + '  Unidad(es)'
                            } else {
                                let otherItem = { cod: item.product.id, total_items: item.total_items }
                                otherItems.push(otherItem)
                            }
                        }
                    })

                    let date = new Date(pO.created_on)
                    date = date.toLocaleDateString()


                    if (pO.hasOwnProperty('customer')) {
                        customerId = pO.customer.dni
                    }
                    posList[pO.id] = { id: pO.id, date: date, total: pO.total, customer: customerId, po: pO }

                    rows.push([pO.id, date, pO.total, pO.pay_method, customerId,
                        targetItem, otherItems,])


                })
                this.setState({ poCatalog: rows, targetPos: posList })



            })
            .catch(error => {
                console.log(error)
                this.setState({ showMsg: true, msgType: 'error', msg: 'Error recuperando Ordenes de compra' })
            })
    }

    setProdToReturn = (prodId, prodPrice, amount) => {
        let prods_to_cr = this.state.prodsToCr
        let pos = this.state.prodsToCr.findIndex(element => element.id == prodId);
        if (pos == -1) {
            prods_to_cr.push({ id: prodId, qty: parseInt(amount), price: prodPrice })

        } else {
            if (parseInt(amount) == 0) {
                prods_to_cr.splice(pos, 1);

            } else {
                prods_to_cr[pos].qty = parseInt(amount)
            }
        }

        let new_total = 0
        prods_to_cr.forEach((prod) => {
            new_total = _.round(new_total + (prod.qty * prod.price), 2)
        });

        // let new_total = _.round(this.state.creditNoteTotal +( prodPrice * parseInt(amount)), 2)
        this.setState({ prodsToCr: prods_to_cr, creditNoteTotal: new_total })
    }

    loadProducts = () => {
        return (<div className='col-md-10'><Table>
            <TableHead>
                <TableRow>
                    <TableCell><b>Codigo</b></TableCell>
                    <TableCell><b>Producto</b></TableCell>
                    <TableCell align="right"><b>Precio</b></TableCell>
                    <TableCell align="right"><b>Cantidad</b></TableCell>
                    <TableCell align="right"><b>Cantidad a retornar</b></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {this.state.poToCr.po.order_items.map((orderItem) => (
                    orderItem.voided != true &&
                    <TableRow key={orderItem.id}>
                        <TableCell>{orderItem.product.id}</TableCell>
                        <TableCell>{orderItem.product.type + ' ' + orderItem.product.brand + ' ' + orderItem.product.model} </TableCell>
                        <TableCell align="right">
                            <NumberFormat
                                value={orderItem.product.price}
                                displayType={'text'}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                prefix="$"
                            />
                        </TableCell>
                        <TableCell align="right">{orderItem.total_items - orderItem.voided_items}</TableCell>
                        <TableCell align="right">
                            <TextField
                                type="number"
                                InputProps={{
                                    inputProps: {
                                        max: orderItem.total_items - orderItem.voided_items, min: 0
                                    }
                                }}
                                prodId={orderItem.product.id}
                                defaultValue={0}
                                onChange={(e) => this.setProdToReturn(orderItem.product.id, orderItem.product.price, e.target.value)}
                            />
                        </TableCell>
                    </TableRow>


                ))}

                <TableRow>
                    <TableCell colSpan={4}><b>Total Nota de credito</b></TableCell>
                    <TableCell align="right"><NumberFormat
                        value={this.state.creditNoteTotal}
                        displayType={'text'}
                        thousandSeparator={'.'}
                        decimalSeparator={','}
                        prefix="$"
                    /></TableCell>
                </TableRow>
            </TableBody>

        </Table></div>
        )
    }

    createCreditNote = (e) => {
        this.setState({ disabledCreate: true })
        if (this.state.prodsToCr.length == 0) {
            this.setState({ showMsg: true, msgType: 'error', msg: 'Seleccione productos', disabledCreate: false })
            return
        }
        let data = { 'products': this.state.prodsToCr, 'po_id': this.state.poToCr.id }
        if (this.state.poToCr['customer'] != '' || this.state.poToCr['customer'] != null) {
            data['customer_id'] = this.state.poToCr['customer']
        }
        PurchaseApi.createCreditNote(data)
            .then(response => {
                this.setState({
                    prodsToCr: [], poCatalog: [], poDate: null, poToCr: null, duration: 90000,
                    targetPos: null, creditNoteTotal: null, showMsg: true, msgType: 'success', msg: response.data.message, disabledCreate: false
                })

            })
            .catch(error => {
                console.log(error)
                this.setState({ showMsg: true, msgType: 'error', msg: 'Error', disabledCreate: false })
            })
    }

    loadVoidedItems = () => {
        const voidedInfo = this.state.poToCr.po.order_items.map((orderItem) => (
            orderItem.voided_items ?
                <TableRow key={orderItem.id}>
                    <TableCell>{orderItem.product.id}</TableCell>
                    <TableCell>{orderItem.product.type + ' ' + orderItem.product.brand + ' ' + orderItem.product.model} </TableCell>
                    <TableCell align="right">
                        <NumberFormat
                            value={orderItem.product.price}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />
                    </TableCell>
                    <TableCell align="right">{orderItem.voided_items}</TableCell>
                </TableRow> : <div></div>

        ))
        console.log(this.state.poToCr)
        const hasVoidedItems = this.state.poToCr.po.order_items.find(item => item.voided_items == true)
        if (hasVoidedItems) {
            return (
                <div className='col-md-10'>

                    <div className='col-md-12' style={{ backgroundColor: "#D4D6D8" }}>

                        <Warning /> <p style={{ marginTop: -25, marginLeft: 25 }}>
                            La orden de compra ya ha generado nota de credito de los siguientes productos
                    </p>
                    </div>
                    <Divider />
                    <br />
                    <TableHead>
                        <TableRow>
                            <TableCell align="center"><b>Codigo</b></TableCell>
                            <TableCell align="center"><b>Producto</b></TableCell>
                            <TableCell align="center"><b>Precio</b></TableCell>
                            <TableCell align="center"><b>Cantidad</b></TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {voidedInfo}
                    </TableBody>

                </div>
            )
        }


    }

    loadCreditNoteItems = () => {
        return (<div className='col-md-10'><Table>
            <TableHead>
                <TableRow>
                    <TableCell align="center"><b>Codigo</b></TableCell>
                    <TableCell align="center"><b>Producto</b></TableCell>
                    <TableCell align="center"><b>Cantidad</b></TableCell>
                    <TableCell align="right"><b>Precio</b></TableCell>

                </TableRow>
            </TableHead>
            <TableBody>
                {this.state.creditNoteSearched.voided_items.map((voided_item) => (
                    <TableRow key={voided_item.product_price}>
                        <TableCell align="center">{voided_item.product.id}</TableCell>
                        <TableCell align="center">{voided_item.product.product_type + ' ' + voided_item.product.brand + ' ' + voided_item.product.model} </TableCell>
                        <TableCell align="center">{voided_item.qty}</TableCell>
                        <TableCell align="right">
                            <NumberFormat
                                value={_.round(voided_item.product_price * voided_item.qty, 2)}
                                displayType={'text'}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                prefix="$"
                            />
                        </TableCell>

                    </TableRow>


                ))}
                <TableRow>
                    <TableCell colSpan={3}><b>Total Nota de credito</b></TableCell>
                    <TableCell align="right"><NumberFormat
                        value={this.state.creditNoteSearched.total}
                        displayType={'text'}
                        thousandSeparator={'.'}
                        decimalSeparator={','}
                        prefix="$"
                    /></TableCell>
                </TableRow>
            </TableBody>

        </Table></div>
        )
    }

    render = () => {
        console.log(this.state.creditNoteSearched)
        return (
            <div>
                <div className='col-md-10' style={{ marginTop: 20 }}>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.newCreditNote}
                                    onChange={(e) => this.setState({ creditNoteToSearch: null, creditNoteSearched: null, newCreditNote: !this.state.newCreditNote })}
                                    color="primary"

                                />
                            }
                            label={this.state.newCreditNote ? 'Crear Nota de Credito' : 'Consultar Nota de Credito'}
                        />
                    </FormGroup>
                </div>
                {this.state.newCreditNote ?
                    <div className='col-md-12' style={{ marginTop: 50 }}>

                        <div className='col-md-12'>
                            <div className='col-md-2'>
                                <TextField
                                    label="Codigo Producto"
                                    value={this.state.prodCod}
                                    onChange={this.setcodProd}
                                    id="prodCod"
                                />
                            </div>

                            <div className='col-md-4'>
                                <ThemeProvider theme={muitheme}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <DatePicker
                                            inputVariant="standard"
                                            variant="dialog"
                                            format="dd/MM/yyyy"
                                            id="po_date"
                                            label="Fecha de Compra"
                                            value={this.state.poDate}
                                            minDate={moment().subtract(21, 'days').toDate()}
                                            onChange={(e) => this.setState({ poDate: e })}

                                        />
                                    </MuiPickersUtilsProvider>
                                </ThemeProvider>
                            </div>

                            <div className='col-md-2 col-md-offset-9'>
                                <Button
                                    onClick={this.loadPurchaseOrders}
                                    variant="contained"
                                    color="primary"
                                    disabled={false}
                                >

                                    Buscar
                        </Button>
                            </div>
                        </div>

                        <br />
                        <br />
                        <Divider />


                        <div className="col-md-12" style={{ marginTop: 70 }} >

                            <MUIDataTable
                                title={this.state.title}
                                data={this.state.poCatalog}
                                columns={this.state.columns}
                                options={options}
                            />
                            <div className='col-md-12' style={{ backgroundColor: "#D4D6D8" }}>

                                <Warning /> <p style={{ marginTop: -25, marginLeft: 25 }}>Clickee la orden de compra para generar una nota de credito</p>
                            </div>
                            {this.state.poToCr ? <div className='col-md-12' style={{ marginTop: 20 }}>
                                <br />
                                <Typography variant="subtitle1" gutterBottom>
                                    Generar nota de credito de Orden: <b>{this.state.poToCr['id']}</b>
                                </Typography>
                                <Divider />
                                <Typography variant="subtitle2" gutterBottom>
                                    Total de la orden: <b><NumberFormat
                                        value={this.state.poToCr['total']}
                                        displayType={'text'}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        prefix="$"
                                    /></b>
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    Fecha de compra: <b>{this.state.poToCr['date']}</b>
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    Cliente: <b>{this.state.poToCr['customer'] || 'ANONIMO'}</b>
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    Forma de pago: <b>{this.state.poToCr['po']['pay_method']}</b>
                                </Typography>
                                <br />
                                <Typography variant="h5" gutterBottom>
                                    Detalle de productos y cantidad
                        </Typography>
                                <br />
                                {this.loadProducts()}
                                <br />
                                {this.loadVoidedItems()}
                                <br />
                                <div className='col-md-2 col-md-offset-9'>
                                    <Button
                                        onClick={this.createCreditNote}
                                        variant="contained"
                                        color="primary"
                                        disabled={this.state.disabledCreate}
                                    >

                                        Generar Nota
                        </Button>
                                </div>

                            </div> : <div></div>}

                            <Divider />

                        </div>


                    </div> :
                    <div className='col-md-12' style={{ marginTop: 20 }}>

                        <div className='col-md-12'>
                            <div className='col-md-2'>
                                <TextField
                                    label="Nota de Credito"
                                    value={!this.state.newCreditNote && this.state.creditNoteToSearch}
                                    onChange={(e) => this.setState({ creditNoteToSearch: e.target.value })}
                                    id="asdas"
                                />
                            </div>
                            <IconButton aria-label="Search"
                                onClick={this.searchCreditNote}
                            >
                                <SearchIcon style={{ marginTop: 10, marginLeft: -15 }} />
                            </IconButton>
                        </div>
                    </div>}

                {this.state.creditNoteSearched && <div className='col-md-12' style={{ marginTop: 20 }}>
                    <br />
                    <Typography variant="h5" gutterBottom>
                        Detalles de la Nota de Credito
                        </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                        <b>Fecha Creacion</b>: {this.state.creditNoteSearched.created_on}
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                        <b>Saldo:</b>
                        <NumberFormat
                            value={this.state.creditNoteSearched.total}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />

                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                        <b>Disponible:</b>  {this.state.creditNoteSearched.used ? <NotInterested style={{ color: 'red' }} /> : <CheckCircleOutline style={{ color: 'green' }} />}

                    </Typography>

                    <br />

                    <Typography variant="h5" gutterBottom>
                        Datos cliente
                        </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                        <b>Nombre:</b>  {this.state.creditNoteSearched.customer_id ? this.state.creditNoteSearched.customer.last_name : 'Anonimo'}
                    </Typography>
                    {this.state.creditNoteSearched.customer_id &&
                        <Typography variant="subtitle2" gutterBottom>
                            <b>DNI:</b>   {this.state.creditNoteSearched.customer.dni}
                        </Typography>
                    }
                    <br />

                    <Typography variant="h5" gutterBottom>
                        Detalles de los productos
                        </Typography>
                    {this.loadCreditNoteItems()}

                </div>}

                <Notification
                    open={this.state.showMsg}
                    variant={this.state.msgType}
                    message={this.state.msg}
                    onClose={this.handleClose}
                    duration={this.state.duration}
                />
            </div>

        )

    }
}


export default CreditNoteView;


// WEBPACK FOOTER //
// ./src/components/Billing/CreditNoteView.js